import React, { useEffect, useRef, useState } from "react";
import App from "./App";
import VeWorldMobileApp from "./mobile/VeWorldMobileApp";

function getForcedMode() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search || "");
  if (params.get("desktop") === "1") return false;
  if (params.get("mobile") === "1") return true;
  return null;
}

function isPhoneLikeDevice() {
  if (typeof window === "undefined") return false;
  const forcedMode = getForcedMode();
  if (forcedMode !== null) return forcedMode;
  const isCoarse = window.matchMedia?.("(pointer: coarse)")?.matches ?? false;
  const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  const uaMobile =
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua);
  const viewportWidth = Math.min(window.innerWidth || 0, window.innerHeight || 0);
  const screenWidth =
    typeof window.screen !== "undefined"
      ? Math.min(window.screen.width || 0, window.screen.height || 0)
      : viewportWidth;
  const looksLikePhoneBySize = viewportWidth <= 540 || screenWidth <= 540;
  return isCoarse && (uaMobile || looksLikePhoneBySize);
}

export default function AppShell() {
  // Wichtig: direkt korrekt initialisieren. Sonst rendert auf Mobile erst <App />
  // und wird nach useEffect auf <VeWorldMobileApp /> gewechselt -> sichtbarer Flicker.
  const [useMobileCompanion, setUseMobileCompanion] = useState(() =>
    isPhoneLikeDevice()
  );
  const modeRef = useRef(useMobileCompanion);

  useEffect(() => {
    let rafId = null;
    const compute = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const forcedMode = getForcedMode();
        const nextMode = isPhoneLikeDevice();
        setUseMobileCompanion((prev) => {
          // Desktop/mobile query params must always win.
          if (forcedMode !== null) {
            modeRef.current = forcedMode;
            return forcedMode;
          }
          // Once mobile is mounted, keep it mounted for this page session. Mobile
          // browser address-bar resize/orientation events can otherwise unmount the
          // whole app shell and create a blank screen during wallet reconnects.
          if (prev && !nextMode) {
            modeRef.current = true;
            return true;
          }
          modeRef.current = nextMode;
          return nextMode;
        });
      });
    };
    compute();
    window.addEventListener("resize", compute, { passive: true });
    window.addEventListener("orientationchange", compute, { passive: true });
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      window.removeEventListener("resize", compute);
      window.removeEventListener("orientationchange", compute);
    };
  }, []);

  return useMobileCompanion ? <VeWorldMobileApp /> : <App />;
}
